import React from 'react';
import { Link } from 'react-router-dom';
import { IoBook, IoSchool, IoTrophy, IoLaptop, IoPeople, IoCheckmarkCircle } from 'react-icons/io5';
import Card from '../../components/common/Card/Card';
import Button from '../../components/common/Button/Button';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import { ROUTES } from '../../constants/routes';
import './Programs.css';

/**
 * Página de Propuesta Educativa - Colegio Bertolt Brecht
 */
const Programs = () => {
    return (
        <div className="programs">
            {/* Page Header */}
            <PageHeader
                title="Propuesta Educativa"
                subtitle="Metodología propia enfocada en el aprendizaje integral del estudiante"
            />

            <div className="container">
                {/* Niveles Educativos */}
                <section className="programs__levels">
                    <h2 className="programs__section-title">Niveles Educativos</h2>
                    <div className="programs__levels-grid">
                        <div className="programs__level-card programs__level-card--primary">
                            <div className="programs__level-icon">
                                <IoBook />
                            </div>
                            <h3>Primaria</h3>
                            <p className="programs__level-description">
                                Metodología enfocada en el aprendizaje con desarrollo de habilidades fundamentales
                            </p>
                            <ul className="programs__level-features">
                                <li><IoCheckmarkCircle /> Acompañamiento personalizado</li>
                                <li><IoCheckmarkCircle /> Actividades lúdicas y pedagógicas</li>
                                <li><IoCheckmarkCircle /> Desarrollo de habilidades básicas</li>
                            </ul>
                        </div>

                        <div className="programs__level-card programs__level-card--secondary">
                            <div className="programs__level-icon">
                                <IoSchool />
                            </div>
                            <h3>Secundaria</h3>
                            <p className="programs__level-description">
                                Currículo avanzado con orientación vocacional y preparación universitaria
                            </p>
                            <ul className="programs__level-features">
                                <li><IoCheckmarkCircle /> Preparación para admisión</li>
                                <li><IoCheckmarkCircle /> Orientación vocacional</li>
                                <li><IoCheckmarkCircle /> Pensamiento crítico</li>
                            </ul>
                        </div>
                    </div>
                </section>

                {/* Servicios de Apoyo */}
                <section className="programs__services">
                    <h2 className="programs__section-title">Servicios de Apoyo</h2>
                    <div className="programs__services-grid">
                        <div className="programs__service-item">
                            <div className="programs__service-icon">📖</div>
                            <h4>Reforzamiento Académico</h4>
                            <p>Clases de apoyo en áreas que requieren mayor atención</p>
                        </div>
                        <div className="programs__service-item">
                            <div className="programs__service-icon">👨‍🏫</div>
                            <h4>Asesoría Personalizada</h4>
                            <p>Atención individual según necesidades del estudiante</p>
                        </div>
                        <div className="programs__service-item">
                            <div className="programs__service-icon">🏆</div>
                            <h4>Círculos de Estudio</h4>
                            <p>Grupos de trabajo colaborativo y aprendizaje entre pares</p>
                        </div>
                    </div>
                </section>

                {/* Programas Clave */}
                <section className="programs__key-programs">
                    <h2 className="programs__section-title">Programas Académicos Clave</h2>
                    <div className="programs__key-grid">
                        <Card hoverable className="programs__key-card">
                            <div className="programs__key-header">
                                <IoBook className="programs__key-icon" />
                                <h3>Plan Lector</h3>
                            </div>
                            <p>Fomenta la lectura y el pensamiento crítico a través de obras seleccionadas</p>
                        </Card>

                        <Card hoverable className="programs__key-card">
                            <div className="programs__key-header">
                                <IoTrophy className="programs__key-icon" />
                                <h3>Simulacros Bimestrales</h3>
                            </div>
                            <p>Preparación constante para exámenes de admisión universitaria</p>
                        </Card>

                        <Card hoverable className="programs__key-card">
                            <div className="programs__key-header">
                                <IoLaptop className="programs__key-icon" />
                                <h3>Plataforma Virtual</h3>
                            </div>
                            <p>Recursos digitales y material educativo disponible 24/7</p>
                        </Card>

                        <Card hoverable className="programs__key-card">
                            <div className="programs__key-header">
                                <IoPeople className="programs__key-icon" />
                                <h3>Acompañamiento</h3>
                            </div>
                            <p>Apoyo emocional y orientación para el bienestar estudiantil</p>
                        </Card>
                    </div>
                </section>

                {/* Metodología */}
                <section className="programs__methodology">
                    <div className="programs__methodology-content">
                        <div className="programs__methodology-text">
                            <h2>Metodología: Enfocado en el Aprendizaje</h2>
                            <p>
                                Nuestra metodología propia coloca al estudiante en el centro del proceso educativo,
                                promoviendo el aprendizaje activo, el pensamiento crítico y el desarrollo de
                                competencias para la vida.
                            </p>
                            <p>
                                Combinamos técnicas pedagógicas innovadoras con valores institucionales para
                                formar ciudadanos íntegros y preparados para los desafíos del futuro.
                            </p>
                            <Link to={ROUTES.ADMISSIONS}>
                                <Button variant="secondary" size="lg">
                                    Solicita Información
                                </Button>
                            </Link>
                        </div>
                        <div className="programs__methodology-visual">
                            <div className="programs__methodology-circle programs__methodology-circle--1"></div>
                            <div className="programs__methodology-circle programs__methodology-circle--2"></div>
                            <div className="programs__methodology-circle programs__methodology-circle--3"></div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Programs;
